// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KnrD","disabled":"styles_disabled__6Rwiq"};